(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trNumbersOnly', trNumbersOnly);

  function trNumbersOnly() {
    const directive = {
      require: 'ngModel',
      link: link
    };
    return directive;

    function link(scope, element, attrs, modelCtrl) {
      modelCtrl.$parsers.push(inputFormatNumber);

      function inputFormatNumber(inputValue) {
        // this next if is necessary for when using ng-required on your input.
        // In such cases, when a letter is typed first, this parser will be called
        // again, and the 2nd time, the value will be undefined
        if (inputValue == undefined) return '';

        const transformedInput = inputValue.replace(/[^0-9+]/g, '');
        if (transformedInput != inputValue) {
          modelCtrl.$setViewValue(transformedInput);
          modelCtrl.$render();
        }
        return transformedInput;
      }

    }
  }
})();
